// src/components/Admin/AdminDashboard.js
import React, { useState } from "react";
import ReservationsList from "./ReservationsList";
import InventoryManagement from "./InventoryManagement";
import CategoryManagement from "./CategoryManagement";
import ReportsOverview from "./ReportsOverview";

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="min-h-screen bg-customWhite p-8">
      <h2 className="text-burgundy text-3xl font-semibold mb-4">
        Admin Dashboard
      </h2>
      <p className="text-navy mb-8">
        Welcome, Admin! Manage your rental business here.
      </p>

      {/* Tab Navigation */}
      <div className="flex space-x-4 mb-8 border-b border-gray-300">
        <button
          onClick={() => setActiveTab('overview')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'overview'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          Overview
        </button>
        <button
          onClick={() => setActiveTab('reservations')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'reservations'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          Reservations
        </button>
        <button
          onClick={() => setActiveTab('inventory')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'inventory'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          Inventory
        </button>
        <button
          onClick={() => setActiveTab('categories')}
          className={`py-2 px-4 font-medium ${
            activeTab === 'categories'
              ? 'text-burgundy border-b-2 border-burgundy'
              : 'text-navy hover:text-burgundy'
          }`}
        >
          Categories
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === 'overview' && (
        <section>
          <h3 className="text-burgundy text-xl font-medium mb-4">
            Business Overview
          </h3>
          <ReportsOverview />
        </section>
      )}
      
      {activeTab === 'reservations' && (
        <section>
          <h3 className="text-burgundy text-xl font-medium mb-4">
            Reservations Management
          </h3>
          <ReservationsList />
        </section>
      )}

      {activeTab === 'inventory' && (
        <section>
          <h3 className="text-burgundy text-xl font-medium mb-4">
            Inventory Management
          </h3>
          <InventoryManagement />
        </section>
      )}

      {activeTab === 'categories' && (
        <section>
          <h3 className="text-burgundy text-xl font-medium mb-4">
            Equipment Categories
          </h3>
          <CategoryManagement />
        </section>
      )}
    </div>
  );
}
